import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store"; 
import { IModalState } from "../../common/types/commonTypes";

const CREATE_EDIT_GROUP_MODAL: string = "createEditGroupModal";

const initialState: IModalState = {
    isActive: false,
    isEditMode: false
};

const createEditGroupModalSlice = createSlice({
    name: CREATE_EDIT_GROUP_MODAL,
    initialState,
    reducers: {
        showModal: (state: IModalState) => {
            state.isActive = true;
        },
        hideModal: (state: IModalState) => {
            state.isActive = false;
            state.isEditMode = initialState.isEditMode;
        },
        turnOnEditMode: (state: IModalState) => {
            state.isEditMode = true;
        }
    }
});

export const actions = {
    createEditGroupModalSlice,
    ...createEditGroupModalSlice.actions,
};

export const selector = (state: RootState) => state.createEditGroupModal;

export const reducer = createEditGroupModalSlice.reducer;
